import { useState, useEffect } from "react";
import { getRequestDetail } from "@apis/user";

const useRequestDetail = (actionSeq, verificationTypeCd) => {
  const [requestData, setRequestData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRequestDetail = async () => {
      if (!actionSeq || !verificationTypeCd) {
        setError("Missing required parameters");
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const response = await getRequestDetail(actionSeq, verificationTypeCd);
        setRequestData(response);
      } catch (err) {
        setError(err.message || "Failed to fetch request details");
        console.error("Error fetching request details:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRequestDetail();
  }, [actionSeq, verificationTypeCd]);

  return { requestData, isLoading, error };
};

export default useRequestDetail; 